export default function ContactSection() {
  return (
    <section id="contact" className="relative py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Contact
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
            Laten we{' '}
            <span className="text-primary-500">kennismaken</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Heeft u een vraag of wilt u een offerte aanvragen? Bel ons, stuur een e-mail of gebruik ons contactformulier.
            Wij reageren doorgaans binnen 24 uur.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="bg-background-100 rounded-3xl p-8 md:p-10 border border-background-200/70 flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-6">
                <i className="ri-mail-send-line text-2xl"></i>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                Stuur ons een bericht
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
                Klik op de knop hieronder om een e-mail te openen in uw eigen e-mailprogramma. 
                Vermeld uw bedrijfsnaam, contactgegevens en een korte omschrijving van uw schoonmaakvraag of project.
              </p>
              <a
                href="mailto:info@a-z-schoon.nl?subject=Offerte%20aanvraag%20A%26Z%20Schoonmaakdienst&body=Beste%20A%26Z%20Schoonmaakdienst%2C%0A%0ANaam%20bedrijf%3A%0AContactpersoon%3A%0ATelefoonnummer%3A%0A%0AType%20schoonmaak%3A%0AOppervlakte%3A%0AUw%20bericht%3A%0A%0AMet%20vriendelijke%20groet%2C"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-mail-line text-base"></i>
                Open e-mail
              </a>
              <p className="text-xs text-foreground-400 mt-5">
                Of e-mail handmatig naar: <span className="text-foreground-600 font-medium">info@a-z-schoon.nl</span>
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-8">
            <div className="bg-background-100 rounded-3xl p-8 md:p-10 border border-background-200/70">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-6">
                Direct contact
              </h3>
              <div className="flex flex-col gap-5">
                <a href="tel://+31641405833" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">Telefoon</div>
                    <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                      06 41 40 58 33
                    </div>
                  </div>
                </a>
                <a href="mailto:info@a-z-schoon.nl" className="flex items-center gap-4 group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">E-mail</div>
                    <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                      info@a-z-schoon.nl
                    </div>
                  </div>
                </a>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500 mb-0.5">Werkgebied</div>
                    <div className="text-sm font-semibold text-foreground-900">
                      Landelijk — heel Nederland
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-accent-100/60 rounded-3xl p-8 md:p-10 border border-accent-200/50">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                Zakelijke vraag?
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                Wij werken uitsluitend voor zakelijke opdrachtgevers. Bent u een bedrijf, winkel, horecazaak of zorginstelling? 
                Neem gerust contact met ons op.
              </p>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-time-line text-accent-600"></i>
                <span>Reactietijd: binnen 24 uur</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}